import React from 'react';

const PageHeader = ({ title, subtitle, actions }) => (
    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
        <div>
            <h1 className="text-2xl font-bold text-slate-900">{title}</h1>
            {subtitle && <p className="text-sm text-slate-500 mt-1">{subtitle}</p>}
        </div>
        {actions && <div className="flex gap-2">{actions}</div>}
    </div>
);

export default PageHeader;
